import { g as _defineProperty, _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var _init_state_quote;
var init_state_quote = (_init_state_quote = {
  quotationNo: '',
  quotationStatus: '',
  quoteCreationDate: '',
  isSaveQuoteEnabled: false,
  isQuoteSubmitting: false,
  isQuoteSaving: false,
  proposalNumber: '',
  isApprover: '',
  currentTab: 0,
  captureMode: 'create',
  addOnCovers: [],
  coverData: {
    addOnCovers: [],
    rawRiskData: []
  },
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  //customer
  customerDetails: {
    customerType: {
      code: '',
      value: ''
    },
    orgInsuredName: '',
    firstName: '',
    middleName: '',
    lastName: ''
  },
  approval_Reason: '',
  approval_Reason_UI: '',
  productVariant: '',
  //quote-wizard-panel-->location-details--> index.js
  briefDetailsOfTheShop: '',
  tradeOrBusiness: '',
  riskLocationDetails: {
    riskLocationAddressLine1: '',
    riskLocationAddressLine2: '',
    riskLocationAddressLine3: '',
    riskLocationAddressLandmark: '',
    townOrCity: '',
    areaLocality: '',
    pinCode: '',
    State: '',
    country: '',
    eqZone: '',
    locationCode: '',
    district: ''
  },
  sectionDetails: {},
  //quote-wizard-panel-->shop-details--> shop-DetailsForm.js     
  // section1:
  // {
  isCheckedSecI: true,
  occupancyI: '',
  buildingSiI: '',
  buildingDescriptionI: '',
  contentSiI: '',
  contentsDescriptionI: '',
  fireSumInsuredI: '',
  sTFIRatePerMilleI: '',
  buildingRatePerMilleI: '',
  contentRatePerMilleI: '',
  discountPerI: '',
  loadingPerI: '',
  sectionIPremiumI: '',
  netPremiumI: '',
  gstI: '',
  stampDutyI: '',
  // },
  // section2:
  // {
  isCheckedSecII: false,
  basisOfIndemnityII: '',
  basisOfSumInsuredII: '',
  indemnityPeriodII: '',
  grossProfitII: '',
  sumInsuredII: '',
  excessII: '',
  rateII: '',
  discountPerII: '',
  discountedRateII: '',
  sectionalDiscountII: '',
  finalRateII: '',
  sectionIIPremiumII: '',
  netPremiumII: '',
  gstII: '',
  stampDutyII: '',
  // },
  // section3:
  // {
  isCheckedSecIII: false,
  basisOfSumInsuredIII: '',
  whetherPolicyOnFirstLossIII: '',
  firstLossPerIII: '',
  firstLossAmountIII: '',
  sumInsuredIII: '',
  excessIII: '',
  rateIII: '',
  discountedRateIII: '',
  sectionalDiscountIII: '',
  finalRateIII: '',
  premiumIII: '',
  netPremiumIII: '',
  gstIII: '',
  stampDutyIII: '',
  // },
  // section4:
  // {
  isCheckedSecIV: false,
  sumInsuredIV: '',
  descriptionIV: '',
  makeModelSrNoIV: '',
  yearOfManufacturingIV: '',
  totalSumInsuredIV: '',
  excessIV: '',
  rateIV: '',
  discountPerIV: '',
  discountedRatePerIV: '',
  sectionalDiscountPerIV: '',
  finalRateIV: '',
  premiumIV: '',
  netPremiumIV: '',
  gstIV: '',
  stampDutyIV: '',
  // },
  // section5:
  // {
  isCheckedSecV: false,
  sumInsuredV: '',
  descriptionV: '',
  makeModelSrNoV: '',
  yearOfManufacturingV: '',
  totalSumInsuredV: '',
  excessV: '',
  rateV: '',
  discountPerV: '',
  discountedRatePerV: '',
  sectionalDiscountPerV: '',
  finalRateV: '',
  premiumV: '',
  netPremiumV: '',
  gstV: '',
  stampDutyV: '',
  // },
  // section6:
  // {
  isCheckedSecVI: false,
  sumInsuredVI: '',
  descriptionVI: '',
  totalSumInsuredVI: '',
  excessVI: '',
  basisOfIndemnityVI: '',
  geographicalLimitVI: '',
  rateVI: '',
  discountPerVI: '',
  discountedRatePerVI: '',
  sectionalDiscountPerVI: '',
  finalRateVI: '',
  premiumVI: '',
  netPremiumVI: '',
  gstVI: '',
  stampDutyVI: '',
  // },
  // section7:
  // {
  isCheckedSecVII: false,
  moneyInSafeSiVII: '',
  moneyInCounterSiVII: '',
  moneyInTransitSiVII: '',
  totalSumInsuredVII: '',
  excessVII: '',
  rateVII: '',
  discountPerVII: '',
  discountedRatePerVII: '',
  sectionalDiscountPerVII: '',
  finalRateVII: '',
  premiumVII: '',
  netPremiumVII: '',
  gstVII: '',
  stampDutyVII: '',
  // },
  // section8:
  // {
  isCheckedSecVIII: false,
  basisVIII: '',
  noOfEmployeesVIII: '',
  sumInsuredVIII: '',
  excessVIII: '',
  rateVIII: '',
  discountPerVIII: '',
  discountedRatePerVIII: '',
  sectionalDiscountPerVIII: '',
  finalRateVIII: '',
  premiumVIII: '',
  netPremiumVIII: '',
  gstVIII: '',
  stampDutyVIII: '',
  // },
  // section9:
  // {
  isCheckedSecIX: false,
  sumInsuredIX: '',
  descriptionIX: '',
  totalSumInsuredIX: '',
  excessIX: '',
  rateIX: '',
  discountPerIX: '',
  discountedRatePerIX: '',
  sectionalDiscountPerIX: '',
  finalRateIX: '',
  premiumIX: '',
  netPremiumIX: '',
  gstIX: '',
  stampDutyIX: '',
  // },
  // section10:
  // {
  isCheckedSecX: false,
  sumInsuredX: '',
  descriptionX: '',
  totalSumInsuredX: '',
  excessX: '',
  rateX: '',
  discountPerX: '',
  discountedRatePerX: '',
  sectionalDiscountPerX: '',
  finalRateX: '',
  premiumX: '',
  netPremiumX: '',
  gstX: '',
  stampDutyX: '',
  // },
  // section11:
  // {
  isCheckedSecXI: false,
  geographicalLimitXI: '',
  sumInsuredXI: '',
  descriptionXI: '',
  totalSumInsuredXI: '',
  excessXI: '',
  rateXI: '',
  discountPerXI: '',
  discountedRatePerXI: '',
  sectionalDiscountPerXI: '',
  finalRateXI: '',
  premiumXI: '',
  netPremiumXI: '',
  gstXI: '',
  stampDutyXI: '',
  // },
  // section12:
  // {
  isCheckedSecXII: false,
  sumInsuredXII: '',
  descriptionXII: '',
  makeModelYearOfManufacturingXII: '',
  totalSumInsuredXII: '',
  excessXII: '',
  rateXII: '',
  discountPerXII: '',
  discountedRatePerXII: '',
  sectionalDiscountPerXII: '',
  finalRateXII: '',
  premiumXII: ''
}, _defineProperty(_init_state_quote, "netPremiumXI", ''), _defineProperty(_init_state_quote, "gstXI", ''), _defineProperty(_init_state_quote, "stampDutyXI", ''), _defineProperty(_init_state_quote, "isCheckedSecXIII", false), _defineProperty(_init_state_quote, "coverageXIII", ''), _defineProperty(_init_state_quote, "nameOfEmployeesOrOwnerXIII", ''), _defineProperty(_init_state_quote, "nameOfNomineeXIII", ''), _defineProperty(_init_state_quote, "relationshipXIII", ''), _defineProperty(_init_state_quote, "detailsOfExistingInfirmityOrDisabilityXIII", ''), _defineProperty(_init_state_quote, "cumulativeBonusXIII", ''), _defineProperty(_init_state_quote, "sumInsuredXIII", ''), _defineProperty(_init_state_quote, "totalSumInsuredXIII", ''), _defineProperty(_init_state_quote, "excessXIII", ''), _defineProperty(_init_state_quote, "rateXIII", ''), _defineProperty(_init_state_quote, "discountPerXIII", ''), _defineProperty(_init_state_quote, "discountedRatePerXIII", ''), _defineProperty(_init_state_quote, "sectionalDiscountPerXIII", ''), _defineProperty(_init_state_quote, "finalRateXIII", ''), _defineProperty(_init_state_quote, "premiumXIII", ''), _defineProperty(_init_state_quote, "netPremiumXIII", ''), _defineProperty(_init_state_quote, "gstXIII", ''), _defineProperty(_init_state_quote, "stampDutyXIII", ''), _defineProperty(_init_state_quote, "isCheckedSecXIV", false), _defineProperty(_init_state_quote, "numberOfEmployeesXIV", ''), _defineProperty(_init_state_quote, "monthlySalaryXIV", ''), _defineProperty(_init_state_quote, "yearlySalaryXIV", ''), _defineProperty(_init_state_quote, "sumInsuredXIV", ''), _defineProperty(_init_state_quote, "totalSumInsuredXIV", ''), _defineProperty(_init_state_quote, "excessXIV", ''), _defineProperty(_init_state_quote, "rateXIV", ''), _defineProperty(_init_state_quote, "discountPerXIV", ''), _defineProperty(_init_state_quote, "discountedRatePerXIV", ''), _defineProperty(_init_state_quote, "sectionalDiscountPerXIV", ''), _defineProperty(_init_state_quote, "finalRateXIV", ''), _defineProperty(_init_state_quote, "premiumXIV", ''), _defineProperty(_init_state_quote, "netPremiumXIV", ''), _defineProperty(_init_state_quote, "gstXIV", ''), _defineProperty(_init_state_quote, "stampDutyXIV", ''), _defineProperty(_init_state_quote, "isCheckedSecXV", false), _defineProperty(_init_state_quote, "limitOfLiabilityEachOccurrenceXV", ''), _defineProperty(_init_state_quote, "limitOfLiabilityAllOccurrencesXV", ''), _defineProperty(_init_state_quote, "retroactiveDateXV", ''), _defineProperty(_init_state_quote, "jurisdictionXV", ''), _defineProperty(_init_state_quote, "excessXV", ''), _defineProperty(_init_state_quote, "sumInsuredXV", ''), _defineProperty(_init_state_quote, "rateXV", ''), _defineProperty(_init_state_quote, "discountPerXV", ''), _defineProperty(_init_state_quote, "discountedRatePerXV", ''), _defineProperty(_init_state_quote, "sectionalDiscountPerXV", ''), _defineProperty(_init_state_quote, "finalRateXV", ''), _defineProperty(_init_state_quote, "premiumXV", ''), _defineProperty(_init_state_quote, "netPremiumXV", ''), _defineProperty(_init_state_quote, "gstXV", ''), _defineProperty(_init_state_quote, "stampDutyXV", ''), _defineProperty(_init_state_quote, "isCheckedSecXVI", false), _defineProperty(_init_state_quote, "limitOfLiabilityEachOccurrenceXVI", ''), _defineProperty(_init_state_quote, "limitOfLiabilityAllOccurrencesXVI", ''), _defineProperty(_init_state_quote, "sumInsuredXVI", ''), _defineProperty(_init_state_quote, "excessXVI", ''), _defineProperty(_init_state_quote, "rateXVI", ''), _defineProperty(_init_state_quote, "discountPerXVI", ''), _defineProperty(_init_state_quote, "discountedRatePerXVI", ''), _defineProperty(_init_state_quote, "sectionalDiscountPerXVI", ''), _defineProperty(_init_state_quote, "finalRateXVI", ''), _defineProperty(_init_state_quote, "premiumXVI", ''), _defineProperty(_init_state_quote, "netPremiumXVI", ''), _defineProperty(_init_state_quote, "gstXVI", ''), _defineProperty(_init_state_quote, "stampDutyXVI", ''), _defineProperty(_init_state_quote, "additionalTabDetails", {
  warranties: {
    defaultWarranties: [],
    userDefinedWarranties: []
  },
  exclusions: {
    defaultExclusions: [],
    userDefinedExclusions: []
  },
  clauses: {
    defaultClauses: [],
    userDefinedClauses: []
  },
  conditions: {
    defaultConditions: [],
    userDefinedConditions: []
  },
  underWriterComments: ''
}), _defineProperty(_init_state_quote, "tabDetails", {
  customerTabDetails: {
    customerDetails: {
      customer: {},
      customerMeta: {} // customerType: {
      //   code: '',
      //   value: '',
      // },
      // firstName: '',
      // middleName: '',
      // lastName: '',
      // orgInsuredName: '',

    },
    policyTenure: {
      code: '',
      value: ''
    },
    policyStartDate: '',
    policyExpiryDate: ''
  }
}), _init_state_quote);
var shopSecQuoteVar = makeVar(init_state_quote);
var initShopSecureQuoteState = function initShopSecureQuoteState(isCopyFromOutside) {
  var _shopSecQuoteVar;

  if (isCopyFromOutside && (_shopSecQuoteVar = shopSecQuoteVar()) !== null && _shopSecQuoteVar !== void 0 && _shopSecQuoteVar.isCopyFromOutside) {
    shopSecQuoteVar(_objectSpread2(_objectSpread2({}, shopSecQuoteVar()), {}, {
      isCopyFromOutside: false
    }));
    return true;
  }

  shopSecQuoteVar(init_state_quote);
  return false;
};
var updateShopSecureQuote = function updateShopSecureQuote(data) {
  shopSecQuoteVar(_objectSpread2(_objectSpread2({}, shopSecQuoteVar()), data));
};
var updateQuotationDetails = function updateQuotationDetails(quotationNo, quotationStatus, quoteCreationDate) // addOnCovers,
// rawRiskData,
{
  // if (addOnCovers && rawRiskData) {
  //   workCompQuoteVar({
  //     ...workCompQuoteVar(),
  //     quotationNo: quotationNo,
  //     quotationStatus: quotationStatus,
  //     quoteCreationDate: quoteCreationDate,
  //     addOnCovers,
  //     rawRiskData,
  //   });
  // } else {
  shopSecQuoteVar(_objectSpread2(_objectSpread2({}, shopSecQuoteVar()), {}, {
    quoteNumber: quotationNo,
    status: quotationStatus,
    quoteCreationDate: quoteCreationDate
  })); // }
};
var updateCustomerInformation = function updateCustomerInformation(customerInformation) {
  return shopSecQuoteVar(_objectSpread2(_objectSpread2({}, shopSecQuoteVar()), {}, {
    customer: customerInformation !== null && customerInformation !== void 0 && customerInformation.customer ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customer : {},
    customerMeta: customerInformation !== null && customerInformation !== void 0 && customerInformation.customerMeta ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customerMeta : {}
  }));
};

export { initShopSecureQuoteState, init_state_quote, shopSecQuoteVar, updateCustomerInformation, updateQuotationDetails, updateShopSecureQuote };
